export class UserProfile {
    public Id?: string = '';
    public Name: string = '';
    public Email: string = '';
    public Role: string = '';
    public Password?: string = '';
}